export default class {
	constructor(obj) {
		this.id = obj.id
		this.link = obj.link
		this.title = obj.title
		this.content = obj.content
        this.status = obj.status
        this.date = obj.date
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/NewsDto.js